import React from 'react'
import { FlagFill, Rocket, Coin, Person, CurrencyEuro } from 'react-bootstrap-icons'
import { formatNumber } from '../../../../utils/Helper'
import computeCampaignKpiMetrics from './computeCampaignKpiMetrics'

const KPI_ICON_CLASS = 'text-rb-text-muted text-xl flex-shrink-0'

function KpiBox({ value, title, icon, showCurrencyPrefix, className = '' }) {
  return (
    <div className={`bg-white dark:bg-rb-dark-mode rounded-lg border-2 border-rb-widget-border dark:border-rb-dark-mode-lighter p-3 ${className}`}>
      <div className="flex items-center">
        {showCurrencyPrefix && <CurrencyEuro className="text-3xl dark:text-white flex-shrink-0" />}
        <span className="font-bold text-3xl px-2 dark:text-white">{value}</span>
      </div>
      <div className="flex justify-between items-center gap-2 mt-1 px-2">
        <p className="font-bold text-xs rb-text-secondary truncate">{title}</p>
        {icon}
      </div>
    </div>
  )
}

export default function KpiMetricsRow({
  campaigns,
  budgetTitle = 'All campaigns budget',
  BudgetIcon = Coin,
  layout = 'spread',
}) {
  const { overallBudget, finishedCount, ongoingCount, influencersWorkedWith } = computeCampaignKpiMetrics(campaigns)
  const boxClassName = layout === 'grid' ? 'min-w-0' : 'min-w-[264px]'
  const sectionClassName = layout === 'grid'
    ? 'grid grid-cols-4 gap-5 w-full'
    : 'flex justify-around w-full mb-1 mr-5'

  return (
    <section className={`z-10 ${sectionClassName}`}>
      <KpiBox value={finishedCount} title="Finished campaigns" icon={<FlagFill className={KPI_ICON_CLASS} />} className={boxClassName} />
      <KpiBox value={ongoingCount} title="Ongoing campaigns" icon={<Rocket className={KPI_ICON_CLASS} />} className={boxClassName} />
      <KpiBox
        value={formatNumber(overallBudget)}
        title={budgetTitle}
        icon={<BudgetIcon className={KPI_ICON_CLASS} />}
        showCurrencyPrefix
        className={boxClassName}
      />
      <KpiBox value={influencersWorkedWith} title="Influencers worked with" icon={<Person className={KPI_ICON_CLASS} />} className={boxClassName} />
    </section>
  )
}
